export const PublicRoutes = {
    'INICIO': 'inicio',
    'ERROR':'error',
    'POSEETARJETAS':'poseetarjetas',
    'SINPRODUCTOS':'sinproductos'
};

export const PrivateRoutes = {    
    'PRIVATE': 'private',
    'TARJETAS': 'tarjetas',
    'DATOSPEROSANLES': 'infopersonal',
    'VERIFICACIONEMAIL': 'verificacionemail',
    'FINALIZAR':'finalizar',
    'GRACIAS':'gracias',
    'APPMOBILE':'appMobile'
}